// extracted by mini-css-extract-plugin
export default {"wrap":"sendMessage_wrap__OJatg"};